export const preventionLevelTypes = [
  { label: "Primaria", value: "PRIMARY" },
  { label: "Secundaria", value: "SECONDARY" },
  { label: "Terciaria", value: "TERTIARY" }
]
